import { useTranslation } from 'next-i18next';
import PropTypes from 'prop-types';

import { NS } from '@/constants';
import { getPriceInfos, getSelectedValue } from '@/utils/categUtils';

import FilterBox from '@/components/categ/filters/FilterBox';
import { FILTERS_TYPE } from '@/constants/categ';

const FiltersLayout = ({ onChange, filters, selectedFiltersInfos = [], open = true }) => {
  const { min: defaultMin, max: defaultMax } = getPriceInfos(selectedFiltersInfos) || {};
  const { t } = useTranslation(NS.COMMON);

  return filters ? filters
    .filter((filter) => {
      if (!filter.displayable) {
        return false;
      }

      if (filter.nbByValue.length > 1) {
        return true;
      }

      // Display a filter that contains one or less option if it has a selected value
      return selectedFiltersInfos.find((s) => s.nameId === filter.nameId);
    })
    .map((filter, index) => {
      let min;
      let max;

      if (filter.type === FILTERS_TYPE.PRICE) {
        min = parseFloat(filter.nbByValue.find(({ value }) => value === 'minPrice')?.valueId);
        max = parseFloat(filter.nbByValue.find(({ value }) => value === 'maxPrice')?.valueId);

        // Sometimes the data is reverse and the <Range> component must not crash !
        if (min > max) {
          [min, max] = [max, min];
        }

        // No need to display the filter if min and max are equal
        if (min === max) {
          return null;
        }
      }

      return (
        <FilterBox
          t={t}
          key={`${filter.nameId}-${filter.nbByValue.length}`}
          filter={filter}
          open={open && [0, 1].includes(index)}
          min={min}
          max={max}
          onChange={onChange}
          defaultMin={defaultMin}
          defaultMax={defaultMax}
          selectedFiltersInfos={selectedFiltersInfos}
          selectedValue={getSelectedValue(filter, selectedFiltersInfos)}
        />
      );
    }) : null;
};

FiltersLayout.propTypes = {
  onChange: PropTypes.func.isRequired,
  filters: PropTypes.array,
  selectedFiltersInfos: PropTypes.array,
  open: PropTypes.bool
};

export default FiltersLayout;
